<template>
  <div class="box">
    <div class="top_box">
      <!--退回-->
      <div class="search_box">
        <img
          class="back_img"
          src="@/assets/homeImgs/black_back.png"
          @click="backToLast"
        />
        <p class="city_text" @click="selectCity">{{ city }}</p>
        <img class="downIcon" src="@/assets/homeImgs/downIcon.png" alt="" />
        <p class="middleLine"></p>
        <img
          class="search_icon"
          src="../../../assets/homeImgs/searchIcon.png"
        />
        <input
          class="input_box"
          v-model="inputValue"
          @input="changeValue"
          type="text"
          v-bind:placeholder="placeHoder"
        />
      </div>
    </div>
    <!--左边菜单栏-->
    <div class="left_box">
      <div
        class="hotViewpoint_text"
        v-for="(item, index) in areaList"
        :key="index"
        @click="selectAreaItem(index)"
      >
        <div
          class="box_bottom_one_item_text"
          :class="{ scenceActive: selectIndex == index }"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <!--右边景点展示-->
    <div class="right_box">
      <div class="content_list">
        <div class="areaDetailList" v-for="(item, index) in list" :key="index">
          <common-title title="甘肃"></common-title>
          <div class="item_box">
            <div
              class="listItem"
              v-for="(views, i) in areaPictureList"
              :key="i"
            >
              <img class="viewImg" src="" />
              <div class="viewName">{{ views.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonTitle from "@/components/common_title.vue";
export default {
  name: "viewpointList",
  components: {
    commonTitle,
  },
  props: {
    city: {
      type: String,
      default() {
        return "城市";
      },
    },
    placeHoder: {
      type: String,
      default() {
        return "请输入您想要搜索的内容";
      },
    },
    hotViewpoint: {
      type: String,
      default() {
        return "热门景点";
      },
    },
  },
  data() {
    return {
      inputValue: "", //输入框的值
      selectIndex: 0, //默认选中第一个
      areaList: [
        "热门景点",
        "西北疆藏",
        "海南福建",
        "云贵川渝",
        "两湖两广",
        "京冀陕北",
        "周边旅游",
      ], //区域菜单list
      list: ["", "", "", ""],
      areaPictureList: [
        {
          url: "",
          name: "敦煌",
        },
        {
          url: "",
          name: "莫高窟",
        },
        {
          url: "",
          name: "甘南",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    //返回
    backToLast() {
      this.$router.go(-1);
    },
    //搜索框输入响应
    inputChange(value) {
      console.log(value);
    },
    selectCity() {
      console.log("选择城市：", this.city);
      this.$emit("selectCity");
    },
    changeValue() {
      console.log(this.inputValue);
      this.$emit("inputChange", this.inputValue);
    },
    //选择活动推荐
    selectAreaItem(index) {
      this.selectIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  background-color: #ffffff;
  height: 100%;

  .top_box {
    .search_box {
      width: vw(630);
      height: vw(72);
      display: flex;
      margin-left: vw(90);
      flex-direction: row;
      align-items: center;
      background-color: #f7f8fa;
      margin-top: vw(20);
      border-radius: vw(100);

      .back_img {
        width: vw(37);
        height: vw(33);
        margin-left: vw(-58);
      }
    }

    .city_text {
      width: vw(100);
      color: #333333;
      font-size: vw(26);
      text-align: right;
    }

    .downIcon {
      margin-left: vw(11.4);
      width: vw(16);
      height: vw(8);
    }

    .middleLine {
      margin-left: vw(24);
      background-color: #d8d8d8;
      width: vw(2);
      height: vw(44);
    }

    .search_icon {
      margin-left: vw(20);
      width: vw(32);
      height: vw(32);
    }

    .input_box {
      margin-left: vw(12);
      color: #333333;
      font-size: vw(26);
      background-color: rgba(255, 255, 255, 0);
      border: 0;
    }
  }

  .left_box {
    position: absolute;
    width: vw(180);
    left: 0;
    top: vw(130);
    bottom: 0;
    background-color: #f7f8fa;

    .hotViewpoint_text {
      top: vw(256);
      text-align: center;
      color: #333333;
      font-size: vw(26);
      .box_bottom_one_item_text {
        padding: vw(20) vw(0);
      }
      .scenceActive {
        background-color: #ffffff;
      }
    }
  }

  .right_box {
    overflow: hidden;
    position: absolute;
    right: 0;
    left: vw(180);
    top: vw(130);
    bottom: 0;
    background-color: #ffffff;
    .content_list {
      height: 100%;
      overflow: auto;
      .areaDetailList {
        padding: 0 vw(30) vw(30) vw(15);
        .item_box {
          margin-left: vw(15);
          display: flex;
          flex-direction: row;
          align-content: flex-start;
          .listItem {
            margin-right: vw(15);
            .viewImg {
              width: vw(160);
              height: vw(160);
              background-color: red;
              border-radius: vw(8);
            }
            .viewName {
              width: vw(160);
              text-align: center;
              font-size: vw(26);
              color: #666666;
            }
          }
        }
      }
    }
  }
}
</style>
